import AuthorityManagementMixin from '@/shared/mixins/authorityManagement/authorityManagementMixin';
import Rules from "@/shared/validators/formRules";
import { mapGetters } from "vuex";
import moment from 'moment';

export default {
  name: "MajorityRules",

  data: () => ({
    compRules: null,
    moment,
  }),

  mixins: [
    AuthorityManagementMixin,
  ],

  methods: {
    majoritiesViewValidation(majorities) {
      return majorities;
    }
  },

  computed: {
    ...mapGetters({
      majorityFilter: 'majority/majorityFilter',
      majorityStatus: 'majority/majorityStatus',
      isRHProtegido: 'user-info/isRHProtegido',
      requestForm: 'majority/requestForm',
      majorities: 'majority/majorities',
      coverages: 'majority/coverages',
    }),

    /**
     * Exibe o componente de status apenas no BACKOFFICE.
     *
     * Regra de negócio: só mostrar o componente de for BACKOFFICE.
     *
     * @returns {boolean} Verdadeiro se for RH Protegido (não mostrar).
     */
    showSubFilterComponent() {
      return !this.isRHProtegido;
    },

    /**
     * Exibe o filtro protocolo apenas para o BACKOFFICE.
     *
     * Regra de negócio: só mostrar o filtro protocolo se for BACKOFFICE.
     *                   além da regra showProtocolFilter
     *
     * @returns {boolean} Verdadeiro se for RH Protegido (não mostrar).
     */
    showProtocolFilter() {
      return this.contractWasSelected && !this.isRHProtegido;
    },

    /**
     * Exibe o filtro de protocolo apenas quando o campo de contrato foi selecionado.
     *
     * Regra de negócio: Apresentar o filtro de protocolo se houver um `contractId` no filtro atual.
     *
     * @returns {boolean} Verdadeiro se o contrato foi selecionado.
     */
    contractWasSelected() {
      return this.majorityFilter.contractId ? true : false;
    },

    /**
     * Exibição do checkbox Permanência indeterminada.
     *
     * Regra de negócio: Apresentar o checkbox Permanência indeterminada se
     *                   Motivo de Permanência for igual
     *                   “Pessoa com Deficiência“ ou “Condição Comercial”
     *
     * @returns {boolean} Verdadeiro se o Motivo for igual
     *                    “Pessoa com Deficiência“ ou “Condição Comercial”
     */
    coverageRules() {
      if (this.coverages.length === 0) return false;
      if (!this.requestForm || !this.requestForm.coverageExtensionReason) return false;

      const coverageForm = this.coverages.find(
        (coverage) => coverage.id === this.requestForm.coverageExtensionReason);
      return [
        'pessoadeficiencia',
        'condicaocomercial'
      ].includes(coverageForm.code);
    },

    /**
     * Regra 1 dos campos Data Limite e Permanência Indeterminada.
     *
     * Regra de negócio:
     *    Caso Motivo de Permanência seja Filho(a) Universitário(a):
     *      Obrigatório o preenchimento do campo Data Limite.
     *
     * @returns {boolean} Verdadeiro se regra acima for cumprida.
     */
    validateCollegeSonRules() {
      // adicionar regra de data
      return this.requestForm.coverageExtensionReason
        && this.requestForm.coverageExtensionLimitDate ? true : false;
    },

    /**
     * Regra 2 dos campos Data Limite e Permanência Indeterminada.
     *
     * Regra de negócio:
     *    Caso Motivo de Permanência seja Pessoa com Deficiência ou Condição Comercial:
     *      Obrigatório o preenchimento de Data Limite ou Permanência Indeterminada.
     *
     * @returns {boolean} Verdadeiro se regra acima for cumprida.
     */
    validatePersonWithDisabilityOrCommercialConditionRules() {
      if (this.requestForm.coverageExtensionReason && this.coverageRules) {
        return this.requestForm.isCoverageLimitIndefinite ||
               this.requestForm.coverageExtensionLimitDate;
      }

      return false;
    },

    limitDateRules() {
      const required = this.compRules.required(this.requestForm.coverageExtensionLimitDate);
      const requiredDate = this.compRules.requiredDate(this.requestForm.coverageExtensionLimitDate);
      const isAfterDateNow = this.compRules.isAfterDateNow(this.requestForm.coverageExtensionLimitDate);

      return [ required, requiredDate, isAfterDateNow ];
    },

    endDateRules() {
      const required = this.compRules.required(this.requestForm.endDate);
      const requiredDate = this.compRules.requiredDate(this.requestForm.endDate);
      const isDateValid = this.compRules.isDateValid(this.requestForm.endDate);
      const isAfterDateNow = this.compRules.isAfterDateNow(this.requestForm.endDate);

      return [ isDateValid, required, requiredDate, isAfterDateNow ];
    },

    isLimitDateValid() {
      const isDateValid = this.compRules.isDateValid(this.requestForm.coverageExtensionLimitDate);
      const isAfterDateNow = this.compRules.isAfterDateNow(this.requestForm.coverageExtensionLimitDate);
      return [ isDateValid, isAfterDateNow ];
    },

    reprocessButtonRules() {
      let rules = {
        disabled: true,
        show: true,
      }

      if (this.isRHProtegido) rules.show = false;
      if (!this.hasPermission('sdi_maioridade_acao_reprocessar')) rules.show =  false;
      if (
        this.majorityFilter.financialGroupId &&
        this.majorityFilter.contractId
      )
        rules.disabled = false;

      if (!this.isReprocessable) rules.disabled = true;

      return rules;
    },

    isReprocessable() {
        return this.hasMajorities &&
               this.majorities.some((majority) => majority.isReprocessable);
    },

    hasMajorities() {
      return this.majorities &&
             this.majorities.length > 0;
    },

    isCurrentCompetence() {
      const isCurrentMonth = parseInt(moment().format('MM')) === this.majorityFilter.competenceMonth;
      const isCurrentYear = parseInt(moment().format('YYYY')) === this.majorityFilter.competenceYear;

      return isCurrentMonth && isCurrentYear;
    },

    exportButtonRules() {
      let rules = {
        disabled: true,
        show: true,
      }

      if (this.majorityFilter.financialGroupId)
        rules.disabled = false;

      if (!this.hasPermission('sdi_maioridade_relatorio')) {
        rules.show = false;
      }

      return rules;
    },
  },

  created() {
    this.compRules = new Rules();
  },
}